import { useState, useEffect } from "react";
import Invoices from "./Invoices";
import Receipts from "./Receipts";
import Quotation from "./Quotation";
import { newGetQuotations } from "../../../../../actions/auth/booking";
import { useSelector, useDispatch } from "react-redux";
import { DownloadNarrowIcon } from "../../../../../components/icons";

const InvoiceAndBIlling = () => {
  const customerQuotation = useSelector((state) => state.customerQuotation);
  const { loading, customerQuotations } = customerQuotation;
  const dispatch = useDispatch();

  const [page, setpage] = useState("Invoices");
  const [menuOpen, setMenuOpen] = useState(false);

  const filterPage = {
    "Invoices": {
      orderBy: "date",
      sortBy: "desc",
      page: 1,
      limit: 10,
      paymentStatus: "NOT_PAID,PAID"
    },
    "Receipts": {
      orderBy: "date",
      sortBy: "desc",
      page: 1,
      limit: 10,
      paymentStatus: "PAID"
    }
  }

  useEffect(() => {
    dispatch(newGetQuotations(filterPage[page]));
  }, [dispatch, page]);

  return (
    <>
      <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:mt-4">
        <div className="tw:flex-1 tw:p-4">
          {/* DESKTOP VIEW */}
          <div className="tw:hidden tw:md:block">
            <ul className="tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none">
              <li className="">
                <a
                  className={`tw:block tw:px-4 tw:py-2 tw:no-underline my-page-booking-nl text-black-30 tw:bg-transparent ${page === "Invoices" ? "active" : ""}`}
                  id="invoices-tab"
                  type="button"
                  role="tab"
                  aria-controls="invoices"
                  aria-selected="true"
                  aria-current="page"
                  href="#"
                  onClick={() => setpage("Invoices")}
                >
                  Invoices
                </a>
              </li>
              <li className="">
                <a
                  className={`tw:block tw:px-4 tw:py-2 tw:no-underline my-page-booking-nl text-black-30 tw:bg-transparent ${page === "Receipts" ? "active" : ""}`}
                  id="receipts-tab"
                  type="button"
                  role="tab"
                  aria-controls="receipts"
                  aria-selected="false"
                  href="#"
                  onClick={() => setpage("Receipts")}
                >
                  Receipts
                </a>
              </li>
              {/* <li className="">
                <a
                  className="tw:block tw:px-4 tw:py-2 tw:no-underline my-page-booking-nl text-black-30 tw:bg-transparent"
                  id="quotations-tab"
                  type="button"
                  role="tab"
                  aria-controls="quotations"
                  aria-selected="false"
                  href="#"
                  onClick={() => setpage("Quotations")}
                >
                  Quotations
                </a>
              </li> */}
            </ul>
          </div>

          {/* MOBILE VIEW */}
          <div className="tw:block tw:md:hidden">
            <div className="tw:grid tw:gap-2">
              <button
                className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none bg-gold-light-100 tw:py-4 tw:rounded-[0.375rem]"
                type="button"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-expanded={menuOpen}
                aria-controls="booking-menu"
              >
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:items-center">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow tw:text-left">{page}</div>
                  <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none">
                    <DownloadNarrowIcon color="#FFFFFF" />
                  </div>
                </div>
              </button>
            </div>
            <div className={menuOpen ? "tw:block" : "tw:hidden"} id="booking-menu">
              <div
                className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:flex-1 tw:p-4 border-gold"
                style={{
                  marginTop: "-3px ",
                  fontSize: "0.875rem",
                }}
              >
                <ul className="tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none tw:flex-col">
                  <li className={`noto ${page === "Invoices" ? "active" : ""}`} role="presentation">
                    <span
                      type="button"
                      role="tab"
                      aria-controls="invoices"
                      aria-selected="true"
                      aria-current="page"
                      onClick={() => { setpage("Invoices"); setMenuOpen(false); }}
                    >
                      Invoices
                    </span>
                  </li>
                  <hr />
                  <li className={`noto ${page === "Receipts" ? "active" : ""}`} role="presentation">
                    <span
                      type="button"
                      role="tab"
                      aria-controls="receipts"
                      aria-selected="false"
                      onClick={() => { setpage("Receipts"); setMenuOpen(false); }}
                    >
                      Receipts
                    </span>
                  </li>
                  {/* <hr />
                  <li className="noto" role="presentation">
                    <span
                      type="button"
                      role="tab"
                      aria-controls="quotations"
                      aria-selected="false"
                      onClick={() => setpage("Quotations")}
                    >
                      Quotations
                    </span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          {/* TAB CONTENT */}
          <div className="" id="invoicesTabContent">
            <div
              className={page === "Invoices" ? "tw:block" : "tw:hidden"}
              id="invoices"
              role="tabpanel"
              aria-labelledby="invoices-tab"
            >
              <Invoices
                loading={loading}
                customerQuotations={customerQuotations}
              />
            </div>
            <div
              className={page === "Receipts" ? "tw:block" : "tw:hidden"}
              id="receipts"
              role="tabpanel"
              aria-labelledby="receipts-tab"
            >
              {/* <Notifications /> */}
              <Receipts
                loading={loading}
                customerQuotations={customerQuotations}
              />
            </div>
            {/* <div
              className="tab-pane fade"
              id="quotations"
              role="tabpanel"
              aria-labelledby="quotations-tab"
            >
              <Quotation />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceAndBIlling;
